import { nsModel } from "../../lib/namespace";

export const paymentMethodNS = nsModel("payment-method");
export const paymentNS = nsModel("payment");
export const autoPayEnrollmentNS = nsModel("autoPayEnrollment");
